'use client';
import { CustomScroll } from '../CustomScroll';
import { FlexWrapper } from '../FlexWrapper';
import styles from './filter.module.sass';
import cn from 'classnames';
import { useEffect, useState } from 'react';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface Itemprops {
    key: string;
    name: string;
    titleResourceKey?: string;
}
interface LoadingProps extends BaseProps {
    isLoading: true;
    activeKey?: string;
    items?: Itemprops[];
    handleOnClick?: (item?: Itemprops) => void;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    activeKey?: string;
    items: Itemprops[];
    handleOnClick?: (item?: Itemprops) => void;
}

export type FiltersProps = LoadingProps | LoadedProps;

export const Filters = ({ items, isLoading, activeKey, handleOnClick, ...props }: FiltersProps) => {
    const [activeFilter, setActiveFilter] = useState<string | null>(activeKey ?? null);
    useEffect(() => {
        setActiveFilter(activeKey ?? null);
    }, [activeKey]);

    const handleFilterClick = (item: Itemprops) => {
        setActiveFilter((prev) => (prev === item.key ? null : item.key));
        handleOnClick && handleOnClick(item);
    };

    return (
        <CustomScroll hidden horizontal className={styles.holder}>
            <FlexWrapper flexDirection="row" gap="1x" {...props} className={cn(styles.filter, props.className)}>
                {items &&
                    items.map((item) => (
                        <span
                            key={item.key}
                            className={cn(styles.item, {
                                [styles.active]: activeFilter?.toLocaleLowerCase() === item.key?.toLocaleLowerCase(),
                            })}
                            onClick={() => handleFilterClick(item)}
                        >
                            {item.name}
                        </span>
                    ))}
            </FlexWrapper>
        </CustomScroll>
    );
};
